<template>
  <div class="grided-template" :style="gridLayoutStyle">
    <MenuComponent @menu-width-change="onMenuWidthChange"></MenuComponent>
    <div>
      <transition name="optimizer-header-slide">
        <default-header v-if="headerVisibility" :visible="true"></default-header>
      </transition>
      <div class="otimizador-main-screen">
        <transition name="optimizer-settings-slide">
          <div v-if="shouldShowStandaloneScenarioPicker" class="standalone-scenario-picker">
            <div class="scenario-picker">
              <button
                type="button"
                class="scenario-picker-button"
                @click.stop="toggleStandaloneScenarioSearch"
                :title="$t('searchScenario')"
              >
                <i class="fas icone fa-ellipsis-h"></i>
              </button>
              <div v-if="showStandaloneScenarioSearch" class="scenario-picker-panel" @click.stop>
                <v-select
                  class="fieldSelected scenario-select"
                  id="cenariosStandalone"
                  v-model="standaloneScenarioPickerValue"
                  :options="cenarios"
                  :getOptionLabel="option => option.DESCR"
                  @input="handleStandaloneScenarioChange"
                  searchable
                  :placeholder="$t('searchScenario')"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :preserve-search="false"
                ></v-select>
              </div>
            </div>
          </div>
        </transition>

        <OtimizadorStep v-if="showStepData" :steps="steps"></OtimizadorStep>
        <transition name="optimizer-settings-slide">
          <OtimizadorSettings v-if="!showStepData && shouldShowSettingsContainer" :class="{ 'headerAproach': headerVisibility == true }" :card="cardData"
            @collumsToHide="hideOrShowCollums" @visibilityMode="visibilityModeChanged" @changeCenario="changeCenario"
            @updateCenarioRequest="updateCenarioRequest" @moveToOriginalCenario="moveToOriginalCenario"
            @generateExcell="generateExcell" @recalculateCosts="recalculateCosts" @removeScenario="removeScenario" 
            @visualizeAntPlates="visualizeAntPlates" @update:feedBackMode="feedBackMode = $event" 
            :feedBackMode="feedBackMode" :nrcenario="nrcenario" :cenarios="cenarios"
            :activeVisibilityMode="exibitionMode"
            :visualizeAntPlatesActive="visualizeAntPlatesActive"></OtimizadorSettings>
        </transition>
        <div v-if="shouldLoad && notShowingCard" class="loader" v-bind:style="'background-image: url(' + loader + ')'">
          <span class="timer" v-if="loader == otloader">
            <div class="timer-center">
              <span id="hora"></span>
              <span id="minuto"></span>
              <span id="segundo"></span>
            </div>
          </span>
        </div>

        <div class="loading-gif" :class="{ 'visible': showSmallLoader }">
          <img :src="loadingGif" />
        </div>

        <div class="otimizador-container" v-bind:class="{ 'loading': shouldLoad == true }">
          <div v-if="showStepData" class="arrow" v-on:click="stepManager" v-bind:style="unclickable">
            <span class="arr">
              <span>▶</span>
            </span>
            <span class="desc">{{ $t('advance') }}</span>
          </div>

          <div v-if="loaded == false && shouldLoad == false && notShowingCard">
            <RegisteredData :updateRegisteredData="updateRegisteredData" :cardData="cardData"></RegisteredData>
          </div>

          <div v-if="showUnconsideredPlates == true">
            <UnconsideredPlatesList :dataFromOtm="dataFromOtm" @chooseAction="callNextStep"></UnconsideredPlatesList>
          </div>

          <div v-if="loaded == true && shouldLoad == false && notShowingCard" class="data-from-food">
            <OtimizadorData :dataFromOtm="dataFromOtm" @editedData="feedData"></OtimizadorData>
          </div>

          <div v-if="notShowingCard == false" class="card-container" ref="cardContainerElement"
            :class="{ 'empty': cardDataNormalizada.length == 0, 'scenario-loading': isScenarioLoading }">
            <div v-if="isScenarioLoading && cardDataNormalizada.length == 0" class="scenario-grid-skeleton">
              <div class="skeleton-labels">
                <span class="skeleton-block fixed"></span>
                <div class="skeleton-grid" :style="scenarioSkeletonGridStyle">
                  <span v-for="col in scenarioSkeletonCols" :key="`skeleton-header-col-${col}`" class="skeleton-block"></span>
                </div>
                <span class="skeleton-block fixed"></span>
              </div>

              <div class="skeleton-body">
                <div v-for="row in scenarioSkeletonRows" :key="`skeleton-row-${row}`" class="skeleton-row">
                  <span class="skeleton-block fixed"></span>
                  <div class="skeleton-grid" :style="scenarioSkeletonGridStyle">
                    <span
                      v-for="col in scenarioSkeletonCols"
                      :key="`skeleton-cell-${row}-${col}`"
                      class="skeleton-block"
                    ></span>
                  </div>
                  <span class="skeleton-block fixed"></span>
                </div>
              </div>
            </div>

            <div v-if="cardDataNormalizada.length == 0 && !isScenarioLoading" class="card-usg-warning">
              <div class="warning" :class="{ 'hideBugIcon': cenarios.length == 0 }">
                <span v-if="cenarios.length > 0">
                  {{ $t('info_scenery') }}
                  <span class="three-dots" aria-hidden="true">
                    <i class="fas fa-ellipsis-h"></i>
                  </span>
                  {{ $t('info_2_scenery') }}
                </span>
                <span v-else>{{ $t('there_is_no_scenario_generated') }}</span>
              </div>
            </div>
            <div v-if="hasResultData" class="result-tab-actions">
              <ActionArrowButton
                :label="$t('result_tab_grid_summary')"
                :title="$t('result_tab_grid_summary_title')"
                desc-position="left"
                :deprecated="activeResultTab === 'grid'"
                @click="setResultTab('grid')"
              >
                <span class="result-tab-icon">
                  <i class="fas fa-table"></i>
                </span>
              </ActionArrowButton>

              <ActionArrowButton
                variant="secondary"
                :label="$t('result_tab_analysis')"
                :title="$t('result_tab_analysis_title')"
                desc-position="left"
                :deprecated="activeResultTab === 'analysis'"
                @click="setResultTab('analysis')"
              >
                <span class="result-tab-icon">
                  <i class="fas fa-clipboard-list"></i>
                </span>
              </ActionArrowButton>

              <ActionArrowButton
                variant="tertiary"
                :label="$t('result_tab_chart')"
                :title="$t('result_tab_chart_title')"
                desc-position="left"
                :deprecated="activeResultTab === 'chat'"
                @click="setResultTab('chat')"
              >
                <span class="result-tab-icon">
                  <i class="fas fa-chart-line"></i>
                </span>
              </ActionArrowButton>
            </div>

            <div v-if="hasResultData" class="result-grid-panel">
              <AnalResult :cardData="cardData" :hideColuns="collumsTohideOrShow"
                :exibitionMode="exibitionMode" :nrcenario="nrcenario" :feedBackMode="feedBackMode" :ingrColors="ingrColors"
                :visualizeAntPlatesActive="visualizeAntPlatesActive" :activeResultTab="activeResultTab"
                :isResultTabSwitching="resultTabIsSwitching"
                @update:feedBackMode="feedBackMode = $event" @updateCenarioFromPlateSub="updateCenarioFromPlateSub"
                @update:visualizeAntPlatesActive="visualizeAntPlatesActive = $event"
                @solver-overrides-changed="handleSolverOverridesChanged"
                @logBuracosExcel="logBuracosExcel" @regerar-cardapio-ia="regerarCardapioIA"></AnalResult>
            </div>

            <transition name="result-tab-switch" mode="out-in">
              <div v-if="hasResultData && resultTabIsSwitching" key="switch-skeleton" class="result-tab-panel result-tab-skeleton">
                <div class="tab-skeleton-header"></div>
                <div class="tab-skeleton-lines">
                  <span v-for="line in 6" :key="`tab-skeleton-${line}`"></span>
                </div>
              </div>

              <div v-else-if="hasResultData && activeResultTab === 'analysis'" key="analysis-panel" class="result-tab-panel">
                <div v-if="hasIgnoredRules" class="card-container-result">
                  <FlexibleRulesComponent :cardData="cardData"></FlexibleRulesComponent>
                </div>
                <div class="card-container-result">
                  <AnalDataContainer :drilldownData="drilldownData"></AnalDataContainer>
                </div>
              </div>

              <div v-else-if="hasResultData && activeResultTab === 'chat'" key="chat-panel" class="result-tab-panel chat-tab-panel">
                <div class="chat-container" v-if="hasChartData">
                  <div class="title">{{ $t('analyze_PU') }}</div>
                  <VueApexCharts class="chart" :width="chartWidth" :height="chartHeight" type="line"
                    :options="chartData.optionsAnalisePU" :series="chartData.serieAnalisePU"></VueApexCharts>
                </div>
                <div v-else class="card-usg-warning chat-empty-warning">
                  <div class="warning">
                    <span>{{ $t('there_is_no_scenario_generated') }}</span>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getSocketInstance } from '@/main.js';
import Util from "@/application/libs/util";
import MenuComponent from "@/components/src/MenuComponent";
import OtimizadorStep from "@/components/src/OtimizadorStep";
import OtimizadorSettings from "@/components/src/OtimizadorSettings";
import OtimizadorData from "@/components/src/OtimizadorData";
import DefaultHeader from "@/components/src/DefaultHeaderComponent";
import AnalResult from "@/components/src/AnalResultComponent";
import AnalDataContainer from "@/components/src/AnalDataContainer";
import RegisteredData from "@/components/src/RegisteredDataComponent";
import UnconsideredPlatesList from "@/components/src/UnconsideredPlatesListComponent";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import RecalculateCostsModal from "@/components/src/modals/RecalculateCostsModal";
import CustoUpdateReportModal from "@/components/src/modals/CustoUpdateReportModal";
import EventModule from "@/application/libs/eventModule";
import requestModule from "@/application/libs/requestModule";
import OptimizerController from "../controllers/OptimizerController";
import ExcelBuilder from "@/application/libs/excelBuilder";
import { t } from 'i18next';
import FlexibleRulesComponent from "@/components/src/FlexibleRulesComponent";
import ActionArrowButton from "@/components/src/ActionArrowButton.vue";

import VueApexCharts from "vue-apexcharts";

export default {
  name: "Optimizer",
  components: {
    DefaultHeader,
    MenuComponent,
    OtimizadorStep,
    OtimizadorSettings,
    OtimizadorData,
    vSelect,
    AnalDataContainer,
    FlexibleRulesComponent,
    ActionArrowButton,
    AnalResult,
    RegisteredData,
    VueApexCharts,
    UnconsideredPlatesList
  },

  data() {
    return {
      view: {
        title: t('optimizer')
      },
      showUnconsideredPlates: false,
      bipSound: require("../../../static/bip.mp3"),
      chartHeight: 500,
      chartWidth: 500,
      updateRegisteredData: true,
      headerVisibility: true,
      showSmallLoader: false,
      feedBackMode: false,
      visualizeAntPlatesActive: false,
      solverOverrides: null,
      nrcenario: null,
      cenarios: [],
      collumsTohideOrShow: [],
      showStepData: true,
      isScenarioLoading: false,
      scenarioSkeletonShape: {
        rows: 8,
        cols: 6,
      },
      timer: null,
      editedData: null,
      unclickable: null,
      currentStep: 0,
      shouldLoad: false,
      notShowingCard: true,
      loader: "",
      loaded: false,
      data: null,
      cardData: {},
      exibitionMode: null,
      steps: [
        {
          name: t('gather_registered_data'),
          active: false
        },
        {
          name: t('confirm_parameters'),
          active: false
        },
        {
          name: t('generate_menu'),
          active: false
        }
      ],
      dtloader: require("../../../static/otimizadordata.gif"),
      otloader: require("../../../static/otimizador.gif"),
      loadingGif: require("../../../static/ic-logo.gif"),
      menuWidth: 100,
      standaloneScenarioPickerValue: null,
      showStandaloneScenarioSearch: false,
      activeResultTab: 'grid',
      resultTabIsSwitching: false,
      resultTabScrollTop: {
        grid: 0,
        analysis: 0,
        chat: 0,
      },
      resultTabSwitchTimeoutId: null,
    };
  },
  computed: {
    shouldShowStandaloneScenarioPicker() {
      const isResultAnalysisScreen = this.$router?.currentRoute?.fullPath === "/ResultAna";
      if (!isResultAnalysisScreen) {
        return false;
      }

      return !this.showStepData && !this.shouldShowSettingsContainer && !this.nrcenario && this.cenarios.length > 0;
    },
    shouldShowSettingsContainer() {
      const isResultAnalysisScreen = this.$router?.currentRoute?.fullPath === "/ResultAna";
      if (!isResultAnalysisScreen) {
        return true;
      }

      return this.menuWidth > 34;
    },
    gridLayoutStyle() {
      return {
        gridTemplateColumns: `${this.menuWidth}px calc(100vw - ${this.menuWidth}px)`
      };
    },
    cardDataNormalizada() {
      if (this.cardData?.tabela?.pratos) {
        return this.cardData.tabela.pratos;
      }

      if (this.cardData?.dataCatalog?.tabela) {
        return this.cardData.dataCatalog.tabela;
      }
      return [];
    },
    hasResultData() {
      return this.cardDataNormalizada.length !== 0;
    },
    hasIgnoredRules() {
      return Boolean(
        this.cardData?.dataCatalog?.ignoredRules &&
        Object.keys(this.cardData?.dataCatalog?.ignoredRules || {}).length !== 0
      );
    },
    hasChartData() {
      return Boolean(this.chartData && this.chartData.serieAnalisePU && this.chartData.serieAnalisePU.length > 0);
    },
    ingrColors() {
      if (!this.cardData) return null;
      return OptimizerController.feedINGData(this.cardData);
    },
    drilldownData() {
      const catalog = this.cardData?.dataCatalog;
      if (!catalog) return [];
      if (this.visualizeAntPlatesActive && this.solverOverrides) {
        const overrides = this.solverOverrides;
        const resolver = (coluna, dia) => {
          const date = dia?.data || '';
          const seq = coluna?.id_coluna != null ? String(coluna.id_coluna).trim() : null;
          const plateId = coluna?.id_prato != null ? String(coluna.id_prato).trim() : null;
          const cellKey = [date, seq || '-', plateId || '-'].join('::');
          const o = overrides[cellKey];
          if (!o) return null;
          return {
            id_prato: o.id_prato,
            perc_consumo: o.perc_consumo,
          };
        };
        return OptimizerController.buildDrilldown(catalog, resolver);
      }
      return OptimizerController.buildDrilldown(catalog);
    },
    chartData() {
      if (!this.cardData?.dataCatalog) return null;
      return OptimizerController.computeChartData(this.cardData);
    },
    scenarioSkeletonRows() {
      const rows = this.scenarioSkeletonShape?.rows || 0;
      return Array.from({ length: rows }, (_, index) => index);
    },
    scenarioSkeletonCols() {
      const cols = this.scenarioSkeletonShape?.cols || 0;
      return Array.from({ length: cols }, (_, index) => index);
    },
    scenarioSkeletonGridStyle() {
      const cols = this.scenarioSkeletonShape?.cols || 1;
      return {
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
      };
    },
  },
  created() {
    EventModule.$on("updateBoData", this.updateRegisteredDataEvent);
    EventModule.$on("costsRecalculated", this.handleCostsRecalculated);
    if (this.$router.currentRoute.fullPath == "/ResultAna") {
      EventModule.$on("updateBoData", this.loadCenarios);
    }
  },
  watch: {
    hasResultData(hasData) {
      if (!hasData) {
        this.activeResultTab = 'grid';
        this.persistResultTabPreference('grid');
        return;
      }
      this.restoreTabScroll(this.activeResultTab);
    },
    nrcenario(newVal) {
      this.standaloneScenarioPickerValue = newVal || null;
    },
    chartData(val) {
      if (val) {
        this.chartWidth  = document.documentElement.clientWidth  / 1.1;
        this.chartHeight = document.documentElement.clientHeight / 1.3;
      }
    }
  },
  beforeDestroy() {
    if (this.resultTabSwitchTimeoutId) {
      clearTimeout(this.resultTabSwitchTimeoutId);
      this.resultTabSwitchTimeoutId = null;
    }
    EventModule.$off("updateBoData", this.loadCenarios);
    EventModule.$off("updateBoData", this.updateRegisteredDataEvent);
    EventModule.$off("costsRecalculated", this.handleCostsRecalculated);
    document.removeEventListener('click', this.closeStandaloneScenarioOverlay);
    this.cardData && Object.keys(this.cardData).forEach(k => delete this.cardData[k]);
  },

  mounted() {
    document.title = `${this.view.title} - Cardápio Inteligente`;
    this.performedFirstTopScrollOnAnalytics = false;

    if (this.$router.currentRoute.fullPath == "/ResultAna") {
      // this.headerVisibility = false;
      this.loaded = false;
      this.shouldLoad = false;
      this.notShowingCard = false;
      this.showStepData = false;
      this.cardData = {
        tabela: { pratos: [] },
        backOfficeData: {
          costType: { NMTIPOCUSTO: "" },
          DTREFECUSTO: ""
        },
        meta: { VLR_CUSTO_MIN: null },
        dataCatalog: {}
      };
      this.cardData = {
        tabela: { pratos: [] },
        backOfficeData: {
          costType: { NMTIPOCUSTO: "" },
          DTREFECUSTO: ""
        },
        meta: { VLR_CUSTO_MIN: null },
        dataCatalog: {}
      };

      this.loadCenarios();
    } else {
      this.steps.map(st => (st.active = false));
      this.steps[0].active = true;
    }

    this.standaloneScenarioPickerValue = this.nrcenario || null;
    this.restoreResultTabPreference();
    document.addEventListener('click', this.closeStandaloneScenarioOverlay);
  },
  methods: {
    normalizeResultTab(tabKey) {
      const validTabs = ['grid', 'analysis', 'chat'];
      return validTabs.includes(tabKey) ? tabKey : 'grid';
    },
    restoreResultTabPreference() {
      const persistedTab = localStorage.getItem('optimizerResultActiveTab');
      this.activeResultTab = this.normalizeResultTab(persistedTab);
    },
    persistResultTabPreference(tabKey) {
      localStorage.setItem('optimizerResultActiveTab', this.normalizeResultTab(tabKey));
    },
    getCardContainerScrollRoot() {
      return this.$refs.cardContainerElement || null;
    },
    saveCurrentTabScroll() {
      const scrollRoot = this.getCardContainerScrollRoot();
      if (!scrollRoot) return;
      this.$set(this.resultTabScrollTop, this.activeResultTab, scrollRoot.scrollTop || 0);
    },
    restoreTabScroll(tabKey) {
      this.$nextTick(() => {
        const scrollRoot = this.getCardContainerScrollRoot();
        if (!scrollRoot) return;
        const savedTop = this.resultTabScrollTop[tabKey] || 0;
        requestAnimationFrame(() => {
          scrollRoot.scrollTop = savedTop;
        });
      });
    },
    setResultTab(tabKey) {
      const normalizedTab = this.normalizeResultTab(tabKey);
      if (this.activeResultTab === normalizedTab && !this.resultTabIsSwitching) {
        return;
      }

      this.saveCurrentTabScroll();
      this.resultTabIsSwitching = true;
      if (this.resultTabSwitchTimeoutId) {
        clearTimeout(this.resultTabSwitchTimeoutId);
        this.resultTabSwitchTimeoutId = null;
      }

      this.resultTabSwitchTimeoutId = setTimeout(() => {
        this.activeResultTab = normalizedTab;
        this.persistResultTabPreference(normalizedTab);
        this.resultTabIsSwitching = false;
        this.restoreTabScroll(normalizedTab);
        this.resultTabSwitchTimeoutId = null;
      }, 140);
    },
    onMenuWidthChange(width) {
      this.menuWidth = width;
    },
    handleStandaloneScenarioChange(cenario) {
      this.standaloneScenarioPickerValue = cenario;
      this.showStandaloneScenarioSearch = false;
      this.changeCenario(cenario);
    },
    toggleStandaloneScenarioSearch() {
      this.showStandaloneScenarioSearch = !this.showStandaloneScenarioSearch;
    },
    closeStandaloneScenarioOverlay(event) {
      const container = this.$el && this.$el.querySelector('.standalone-scenario-picker');
      if (!container) return;
      if (!container.contains(event.target)) {
        this.showStandaloneScenarioSearch = false;
      }
    },
    playBeep: function () {
      var audio = new Audio(this.bipSound);
      audio.play();
    },
    updateRegisteredDataEvent: function () {
      if (this.currentStep != 0) {
        window.location.reload();
      }
      this.updateRegisteredData = !this.updateRegisteredData;
    },
    updateCenarioRequest: function (data) { },
    hideOrShowCollums: function (data) {
      this.collumsTohideOrShow = data;
    },
    updateCenarioFromPlateSub: function (newCardData) {
      this.cardData = newCardData;
      this.showStepData = false;
      this.insertCenario(this.nrcenario.NRCENARIOCARD);
    },
    regerarCardapioIA: function () {
      this.showStepData = false;
      this.insertCenario(null);
    },
    moveToOriginalCenario: function (data) {
      let cenario = this.cenarios.find(c => c.NRCENARIOCARD == data);
      this.changeCenario(cenario);
    },
    fetchIncidencia: function () {
      // Usa o filtro gravado junto ao cenário, para que a incidência corresponda ao
      // mês/filial/serviço dele mesmo que o filtro da sessão já tenha sido trocado.
      const bo = this.cardData?.backOfficeData || Util.getFilterInSession();
      const queryString = new URLSearchParams({
        P_CDFILIAL: bo.CDFILIAL,
        P_CDSERVFILI: bo.CDSERVFILI,
        P_DTMESCARD: bo.DTMESCARD,
        P_NRTIPOCUSTO: bo.NRTIPOCUSTO,
        P_IDTIPORESTRICAO: bo.TPCONTRATO,
        P_CDFILICUSTO: bo.CDFILICUSTO
      }).toString();

      return requestModule
        .postRequest(`getIncidenciaTpGpPrato?${queryString}`, {})
        .then(response => {
          const incidencia_tp_gp_prato = response && response.dataset && response.dataset.incidencia_tp_gp_prato;
          // Em erro de SQL o backend devolve status != SUCCESS e `data` como string,
          // que quebraria dentro de addIncidencia_tp_gp_prato com um erro sem contexto.
          if (!incidencia_tp_gp_prato || !Array.isArray(incidencia_tp_gp_prato.data)) {
            throw new Error(
              `incidencia_tp_gp_prato inválida: ${JSON.stringify(incidencia_tp_gp_prato)}`
            );
          }
          return OptimizerController.addIncidencia_tp_gp_prato({ incidencia_tp_gp_prato }).incidencia;
        });
    },
    compExcellBuilder: async function () {
      let incListCopy;
      this.showSmallLoader = true;
      try {
        incListCopy = await this.fetchIncidencia();
      } catch (error) {
        console.log(error);
        Util.showErrorNotification({
          text: t('reload_the_page_and_try_again'),
          title: t('error_contacting_the_server')
        });
        return;
      } finally {
        this.showSmallLoader = false;
      }
      let { label, data } = OptimizerController.generateCompExcell(
        OptimizerController.buildDiasFromCatalog(this.cardData.dataCatalog),
        incListCopy,
        OptimizerController.buildColInfoFromCatalog(this.cardData.dataCatalog),
        OptimizerController.getPuAcumlFromCatalog(this.cardData.dataCatalog)
      );
      var title = Util.getExcelHeaderFromFilter();
      const conditionalFormatterRules = [
        {
          "type": "cellIs",
          "formulae": [
            "0"
          ],
          "operator": "greaterThan",
          "style": {
            "font": {
              "color": {
                "argb": "FFFF0000"
              }
            }
          }
        },
        {
          "type": "cellIs",
          "formulae": [
            "0"
          ],
          "operator": "lessThan",
          "style": {
            "font": {
              "color": {
                "argb": "FF008000"
              }
            }
          }
        }
      ]
      title = t('comparative_optimized_menu') + ' ' + title[0].value.replace(/\//g, "-") + ', ' + t('unit') + ' ' + title[3].value + ', ' + t('service') + ' ' + title[5].value;
      const columnLetter = (index) => String.fromCharCode(65 + index); // A=65 no ASCII
      // Localiza os índices pelos keys desejados
      const desiredKeys = ['puotmmescorrente', 'puotmmediapu'];
      const columnRefs = desiredKeys.map(key => {
        const columnIndex = label.findIndex(col => col.key === key);
        return columnIndex !== -1 ? `${columnLetter(columnIndex)}5:${columnLetter(columnIndex)}65536` : null;
      }).filter(ref => ref !== null); // Remove referências nulas

      // Modifica valores nulos apenas na primeira linha de `data`
      if (data[0]) {
        const firstRow = data[0];
        // Coleta todas as chaves existentes nos objetos de `data`
        const allKeys = new Set();
        data.forEach((row) => {
          Object.keys(row).forEach((key) => allKeys.add(key));
        });

        // Adiciona chaves ausentes em `data[0]` com valor '--'
        allKeys.forEach((key) => {
          if (!(key in firstRow)) {
            firstRow[key] = "--";
          }
        });
        Object.keys(firstRow).forEach((key) => {
          if (firstRow[key] === null) {
            firstRow[key] = "--";
          }
        });
      }

      ExcelBuilder.fromJson(
        data,
        label,
        title,
        [].concat(Util.getExcelHeaderFromFilter(), [
          { label: t('scenery'), value: this.nrcenario.NRCENARIOCARD }
        ]),
        {
          options: {
            views: [
              { state: 'frozen', ySplit: 5, xSplit: 2 }
            ]
          },
          conditionalFormatting: columnRefs.map(ref => ({ ref, rules: conditionalFormatterRules })), // Aplica regras para as colunas encontradas
        }
      );
    },
    cardExcellBuilder: function (format) {
      let { label, data } = OptimizerController.generateCardExcell(this.cardData.dataCatalog, format === 'numero');
      var title = Util.getExcelHeaderFromFilter();
      title = t('optimized_menu') + ' ' + title[0].value.replace(/\//g, "-") + ', ' + t('unit') + ' ' + title[3].value + ', ' + t('service') + ' ' + title[5].value;
      ExcelBuilder.fromJson(
        data,
        label,
        title,
        [].concat(Util.getExcelHeaderFromFilter(), [
          { label: t('scenery'), value: this.nrcenario.NRCENARIOCARD }
        ])
      );
    },
    logBuracosExcel: function () {
      let { label, newArrExcel } = OptimizerController.generatelogBuracosExcel(this.cardData.cardapio.datas);
      var title = Util.getExcelHeaderFromFilter();
      title = t('inconsistencies_in_the_scenario') + ' ' + title[0].value.replace(/\//g, "-") + ', ' + t('unit') + ' ' + title[3].value + ', ' + t('service') + ' ' + title[5].value;
      const conditionalFormatterRules = [{
        "type": "cellIs",
        "formulae": [
          "0"
        ],
        "operator": "greaterThan",
        "style": {
          "font": {
            "color": {
              "argb": "FFFF0000"
            }
          }
        }
      },
      {
        "type": "cellIs",
        "formulae": [
          "0"
        ],
        "operator": "lessThan",
        "style": {
          "font": {
            "color": {
              "argb": "FF008000"
            }
          }
        }
      }]

      ExcelBuilder.fromJson(
        newArrExcel,
        label,
        title,
        [].concat(Util.getExcelHeaderFromFilter(), [
          { label: t('scenery'), value: this.nrcenario.NRCENARIOCARD }
        ]),
        {
          options: {
            views: [
              { state: 'frozen', ySplit: 4, xSplit: 2 }
            ]
          },
          conditionalFormatting: [
            { ref: "R5:R65536", rules: conditionalFormatterRules },
            { ref: "T5:T65536", rules: conditionalFormatterRules }
          ]
        }
      );
    },
    recalculateCosts: function() {
      if (!this.cardData?.dataCatalog?.tabela) {
        return false;
      }
      this.$modal.show(RecalculateCostsModal, {
        cardData: this.cardData,
        nrcenario: this.nrcenario
      }, {
        height: 'auto',
        clickToClose: false
      });
    },
    handleCostsRecalculated: function ({ dataCatalog, custoUpdateReport, costType, DTREFECUSTO } = {}) {
      this.cardData = {
        ...this.cardData,
        dataCatalog: dataCatalog ?? this.cardData?.dataCatalog ?? {},
        backOfficeData: {
          ...this.cardData?.backOfficeData,
          costType: costType ?? this.cardData?.backOfficeData?.costType,
          DTREFECUSTO: DTREFECUSTO ?? this.cardData?.backOfficeData?.DTREFECUSTO
        }
      };

      if (costType) Util.setBackOfficeData("costType", costType);
      if (DTREFECUSTO) Util.setBackOfficeData("DTREFECUSTO", DTREFECUSTO);

      this.$modal.show(CustoUpdateReportModal, {
        report: custoUpdateReport
      }, {
        height: 'auto',
        width: '80%',
        clickToClose: true
      });
    },
    generateExcell: function () {
      if (!this.cardData?.dataCatalog?.tabela) {
        return false;
      }
      let sf = this;
      this.$modal.show({
        template: `
              <div id="default-modal">
                <a class="confirm-label">{{$t('which_report_do_you_want_to_issue')}}</a>
                <div class="buttons-container">
                  <!--<div class="button" id="inconsistencia" @click="inconsistencia">
                        {{$t('inconsistencies_in_the_scenario')}}
                  </div>-->

                  <div class="button" id="comparativo" @click="comparativo">
                      {{$t('comparison_menu_vs_scenery')}}
                  </div>

                  <div class="button" id="confirm" @click="numero">
                      {{$t('menu_number_of_diners')}}
                  </div>
                  
                  <div class="button" id="cancel" @click="porcentagem">
                      {{$t('menu_percentage_diners')}}
                  </div>
                </div>
              </div>
          `,
        methods: {
          comparativo() {
            sf.compExcellBuilder();
            this.$emit('close');
          },
          numero() {
            sf.cardExcellBuilder('numero');
            this.$emit('close');
          },
          porcentagem() {
            sf.cardExcellBuilder('porcentagem');
            this.$emit('close');
          },
          inconsistencia() {
            sf.logBuracosExcel();
            this.$emit('close');
          }
        }
      }, {}, {
        height: 'auto',
        resizable: false
      });
    },
    changeCenario: function (newCenario) {
      if (!newCenario) {
        return Promise.resolve();
      }
      this.visualizeAntPlatesActive = false;
      this.prepareScenarioSkeleton();
      this.isScenarioLoading = true;
      this.nrcenario = {
        ...newCenario,
        VERSAORELATORIOIA: null,
        STATUSRELATORIOIA: null,
      };
      this.showSmallLoader = true;
      return requestModule
        .postRequest(`getData`, {
          FROM: "CENARIO",
          PARAMS: {
            NRCENARIOCARD: this.nrcenario.NRCENARIOCARD,
            NRORG: Util.getLocalVar("userData").NRORG
          }
        })
        .then(response => {
          const cenarioSelecionado = response?.dataset?.data?.[0];
          if (!cenarioSelecionado) {
            return;
          }

          this.headerVisibility = false;
          this.nrcenario = {
            ...this.nrcenario,
            VERSAOCENARIO: cenarioSelecionado.VERSAOCENARIO ?? null,
            VERSAORELATORIOIA: cenarioSelecionado.VERSAORELATORIOIA ?? null,
            STATUSRELATORIOIA: cenarioSelecionado.STATUSRELATORIOIA ?? null,
          };

          let parsedCenario = cenarioSelecionado.JSONCENARIO;
          let dataCatalog = cenarioSelecionado.JSONCARDAPIO;
          parsedCenario = JSON.parse(parsedCenario);
          // só faz parse se for string
          if (typeof dataCatalog === 'string') {
            try {
              dataCatalog = JSON.parse(dataCatalog);
            } catch (e) {
              console.error('Erro ao fazer parse do JSONCARDAPIO:', e);
              dataCatalog = null;
            }
          }
          OptimizerController.fixIdPrato(dataCatalog, Util.getFilterInSession().CDFILIAL);

          let rawDate = cenarioSelecionado.DTEXPIRACAO;
          let formattedDate = rawDate ? moment(rawDate, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY") : null;
          parsedCenario.DTEXPIRACAO = formattedDate;
          this.cardData = {
            ...parsedCenario,
            dataCatalog: dataCatalog ?? {}
          };
          let costType = this.cardData?.backOfficeData?.costType;
          let dtRefeCusto = this.cardData?.backOfficeData?.DTREFECUSTO;
          if (costType) Util.setBackOfficeData("costType", costType);
          if (dtRefeCusto) Util.setBackOfficeData("DTREFECUSTO", dtRefeCusto);
          
          const { cardContainerElement } = this.$refs;

          if (!this.performedFirstTopScrollOnAnalytics) {
            this.performedFirstTopScrollOnAnalytics = true;
            setTimeout(
              () => (cardContainerElement.style.scrollSnapType = "y mandatory"),
              1
            );
          }
        })
        .finally(() => {
          this.showSmallLoader = false;
          this.isScenarioLoading = false;
          if(this.cardData?.dataCatalog) console.log("dataCatalog",this.cardData);
        });
    },
    prepareScenarioSkeleton: function () {
      const fallbackShape = { rows: 8, cols: 6 };
      const tabela = this.cardData?.dataCatalog?.tabela;

      if (!Array.isArray(tabela) || !tabela.length) {
        this.scenarioSkeletonShape = fallbackShape;
        return;
      }

      const rows = tabela.length;
      const firstRowWithColumns = tabela.find(dia => Array.isArray(dia?.colunas) && dia.colunas.length);
      const columns = firstRowWithColumns?.colunas || [];
      const visibleCols = columns.filter(coluna => !this.collumsTohideOrShow.includes(coluna.id_coluna)).length;

      this.scenarioSkeletonShape = {
        rows: rows > 0 ? rows : fallbackShape.rows,
        cols: visibleCols > 0 ? visibleCols : fallbackShape.cols,
      };
    },
    visualizeAntPlates: function () {
      this.visualizeAntPlatesActive = !this.visualizeAntPlatesActive;
      if (!this.visualizeAntPlatesActive) {
        this.solverOverrides = null;
      }
    },
    handleSolverOverridesChanged: function (overrides) {
      this.solverOverrides = overrides || null;
    },
    removeScenario: function (newCenario) {
      Util.showConfirmationDialog(this.$modal, () => {
        this.showSmallLoader = true;
        requestModule
          .postRequest(`updateData`, {
            FROM: "CENARIOATIVO",
            PARAMS: {
              NRCENARIOCARD: newCenario.NRCENARIOCARD,
              NRORG: Util.getLocalVar("userData").NRORG
            }
          })
          .then(response => {
            // Reset para estado sem cenário selecionado
            this.nrcenario = null;
            this.cardData = {
              tabela: { pratos: [] },
              backOfficeData: {
                costType: { NMTIPOCUSTO: "" },
                DTREFECUSTO: ""
              },
              meta: { VLR_CUSTO_MIN: null },
              dataCatalog: {}
            };
            this.cardData = {
              tabela: { pratos: [] },
              backOfficeData: {
                costType: { NMTIPOCUSTO: "" },
                DTREFECUSTO: ""
              },
              meta: { VLR_CUSTO_MIN: null },
              dataCatalog: {}
            };
            this.showStepData = false;
            this.notShowingCard = false;
            this.loaded = false;
            this.shouldLoad = false;

            // Recarregar a lista de cenários para remover o deletado
            this.loadCenarios();
          })
          .finally(() => {
            this.showSmallLoader = false;
          });
      }, t('delete_scenario'));
    },
    activefeedBackMode() {
      this.feedBackMode = !this.feedBackMode;
    },
    checkDataFullness: function () {
      if (
        !(
          Util.getFilterInSession().DTMESCARD &&
          Util.getLocalVar("userData").CDOPERADOR &&
          Util.getFilterInSession().VRCUSTPADR &&
          Util.getFilterInSession().VLR_CUSTO_MIN &&
          Util.getFilterInSession().VLR_CUSTO_MAX
        )
      ) {
        Util.showErrorNotification({
          text: t('fill_in_all_the_necessary_data_to_generate_the_menu'),
          title: t('incomplete_data')
        });

        return false;
      }
      return true;
    },
    firstStep: function () {
      EventModule.$emit("next-step-optimizer", 1);
      if (this.checkDataFullness()) {
        this.currentStep++;

        this.unclickable = "pointer-events: none;";
        this.shouldLoad = true;
        this.loader = this.dtloader;

        let reqPar = {
          url_in: `getGenData`,
          P_CDFILIAL: Util.getFilterInSession().CDFILIAL,
          P_CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
          P_DTREFCUSPADR: Util.getFilterInSession().DTMESCARD,
          P_IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO,
          P_DTMESCARD: Util.getFilterInSession().DTMESCARD,
          P_NRTIPOCUSTO: Util.getFilterInSession().NRTIPOCUSTO,
          P_DTREFECUSTO: Util.getFilterInSession().DTREFECUSTO,
          P_DTMES: Util.getFilterInSession().DTMESCARD,
          P_DIAS_CONG: Util.getFilterInSession().VLR_CONGELADO,
          P_DIA_SEMANA: Util.getFilterInSession().P_DIA_SEMANA,
          P_CDNVPRATO: Util.getPlateNivel(),
          P_IDUTRPADCA: Util.getFilterInSession().IDUTRPADCA,
          P_CDFILICUSTO: Util.getFilterInSession().CDFILICUSTO
        };

        requestModule
          .postRequest(
            `${reqPar.url_in}?P_CDFILIAL=${reqPar.P_CDFILIAL}&P_CDFILICUSTO=${reqPar.P_CDFILICUSTO}&P_CDSERVFILI=${reqPar.P_CDSERVFILI}&P_DTREFCUSPADR=${reqPar.P_DTREFCUSPADR}&P_IDTIPORESTRICAO=${reqPar.P_IDTIPORESTRICAO}&P_DTMESCARD=${reqPar.P_DTMESCARD}&P_NRTIPOCUSTO=${reqPar.P_NRTIPOCUSTO}&P_DTREFECUSTO=${reqPar.P_DTREFECUSTO}&P_DTMES=${reqPar.P_DTMES}&P_DIAS_CONG=${reqPar.P_DIAS_CONG}&P_DIA_SEMANA=${reqPar.P_DIA_SEMANA}&P_CDNVPRATO=${reqPar.P_CDNVPRATO}&P_IDUTRPADCA=${reqPar.P_IDUTRPADCA}`,
            {}
          )
          .then(response => {
            this.shouldLoad = false;
            this.loaded = true;
            this.loader = "";


            this.dataFromOtm = response.dataset;

            this.steps[1].active = true;
            this.headerVisibility = false;
          })
          .catch(error => {
            console.log(error);
            this.currentStep = 0;
          })
          .finally(() => {
            this.unclickable = "pointer-events: auto;";
          });
      } else {
        this.currentStep = 0;
      }
    },
    feedData: function (data) {
      this.editedData = Object.assign({}, data);
    },
    insertCenario: function (NRCENARIOCARD = null) {
      // incidencia é descartada: passou a ser buscada sob demanda na geração do Excel
      // comparativo, então não precisa mais ser serializada dentro do JSONCENARIO.
      const { dataCatalog, incidencia, ...cardData } = this.cardData;
      requestModule
        .postRequest(`insertData`, {
          FROM: "CENARIO",
          PARAMS: {
            NRCENARIOCARD,
            CDFILIAL: Util.getFilterInSession().CDFILIAL,
            CDFILICUSTO: Util.getFilterInSession().CDFILICUSTO,
            CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
            DTMESCARD: Util.getFilterInSession().DTMESCARD,
            CDOPERADOR: Util.getLocalVar("userData").CDOPERADOR,
            JSONCENARIO: JSON.stringify(cardData),
            correlationId: cardData.correlationId ?? null,
            JSONCARDAPIO: JSON.stringify(dataCatalog),
            VRCUSTPADR: this.cardData.P_VRCUSTPADR,
            IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO,
            QTCOMENSAIS: this.cardData.comensal_total,
            VRPUCENARIO: this.cardData.pu_aculm
              ? this.cardData.pu_aculm.toFixed(5)
              : "",
            NRTIPOCUSTO: Util.getFilterInSession().NRTIPOCUSTO || null,
            DTREFECUSTO: Util.getFilterInSession().DTREFECUSTO || null,
            NRCENARIOVINCULO: Util.getFilterInSession().NRCENARIOVINCULO || null,
            NRORG: Util.getLocalVar("userData").NRORG,
          },
        })
        .then((response) => {
          Util.showSuccessNotification({
            text: `Salvo às ${moment().format("HH:mm:ss")}`,
            title: t('saved_scenario'),
          });
          if (response) {
            let nrcenarioResp = response.dataset.data.NRCENARIOCARD;
            let versaoCenarioResp = response.dataset.data.VERSAOCENARIO ?? null;
            let versaoRelatorioIAResp = response.dataset.data.VERSAORELATORIOIA ?? null;
            let statusRelatorioIAResp = response.dataset.data.STATUSRELATORIOIA ?? null;
            if (this.nrcenario && parseInt(this.nrcenario.NRCENARIOCARD) === parseInt(nrcenarioResp)) {
              this.nrcenario = {
                ...this.nrcenario,
                VERSAOCENARIO: versaoCenarioResp,
                VERSAORELATORIOIA: versaoRelatorioIAResp,
                STATUSRELATORIOIA: statusRelatorioIAResp
              };
            }
            this.loadCenarios(nrcenarioResp, {
              scenarioStateFromInsert: {
                VERSAOCENARIO: versaoCenarioResp,
                VERSAORELATORIOIA: versaoRelatorioIAResp,
                STATUSRELATORIOIA: statusRelatorioIAResp
              }
            });
            this.playBeep();
            if (NRCENARIOCARD && response.dataset.data.NRITGERACAOCARD) { // updateScenary
              const {
                NRGERACAOCARD,
                NRITGERACAOCARD,
                NRCENARIOPUBLICAR
              } = response.dataset.data;
              let socket = getSocketInstance();
              if (socket.connected === true) {
                requestModule.postRequestOtmNode('notifyClients', {
                  EVENT_NAME: 'onUpdateScenary',
                  MESSAGE: {
                    NRGERACAOCARD,
                    NRITGERACAOCARD,
                    NRCENARIOPUBLICAR
                  }
                });
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    callNextStep: function (action) {
      this.showUnconsideredPlates = false;
      if (!action) {
        return;
      }
      const pratoSemHistorico = this.dataFromOtm?.prato_sem_historico?.data;
      if (Array.isArray(pratoSemHistorico) && pratoSemHistorico.length > 0) {
        this.confirmPratoSemHistorico();
      } else {
        this.secondStep(true);
      }
    },
    confirmPratoSemHistorico: function () {
      let sf = this;
      this.$modal.show({
        template: `
              <div id="default-modal">
                <a class="confirm-label">{{$t('consider_dishes_without_history_in_the_menu')}}</a>
                <div class="buttons-container">
                  <div class="button" style="width: 50%" id="confirm" @click="responder(true)">
                      {{$t('yes')}}
                  </div>

                  <div class="button" style="width: 50%" id="cancel" @click="responder(false)">
                      {{$t('no')}}
                  </div>
                </div>
              </div>
          `,
        methods: {
          responder(status) {
            this.$emit('close');
            sf.secondStep(status);
          }
        }
      }, {}, {
        height: 'auto',
        resizable: false
      });
    },
    removeReceitaPratoIfNotFrequencia: function (cloneData, cloneEditedData) {
      if ((cloneEditedData.frq_grupo_prato_mes.find(f => f.withoutFreq) && cloneEditedData.frq_grupo_prato_mes.find(f => f.withoutFreq).Ativo == false) && cloneData.frq_grupo_prato_mes.data.length) {
        cloneData.receita_prato.data = cloneData.receita_prato.data.filter(p => cloneData.frq_grupo_prato_mes.data.find(f => f.NUM_GRP_PRATO == p.NUM_GRP_PRATO));
      }
      cloneEditedData.frq_grupo_prato_mes.pop();
    },
    // função para remover pratos inativos e com preço negativo
    removeInativoEsemPreço: function (cloneData) {
      // cloneData.receita_prato.data = cloneData.receita_prato.data.filter(p => p.IDPRODATIVPR == "S" && p.IDPRODATIV == "A");
      cloneData.receita_prato.data = cloneData.receita_prato.data.filter(p => {
        const produtoAtivo = p.IDPRODATIVPR === "S" && p.IDPRODATIV === "A";
        const semCusto = !p.semCusto;
        return produtoAtivo && semCusto;
      });
    },
    secondStep: function (enviarPratoSemHistorico = true) {
      this.unclickable = "pointer-events: none;";
      let cloneData = JSON.parse(JSON.stringify(this.dataFromOtm));
      let cloneEditedData = Object.assign({}, this.editedData);
      let cons = Object.keys(this.editedData);
      this.removeReceitaPratoIfNotFrequencia(cloneData, cloneEditedData);
      this.removeInativoEsemPreço(cloneData);
      delete cloneData.prato_sem_historico;
      for (let i = 0; i < cons.length; i++) {
        const dataSource = cons[i];
        delete cloneEditedData[dataSource].Ativo;
        cloneData[dataSource].data = this.editedData[dataSource].filter(
          ds => ds.Ativo != false
        );
      }
      this.shouldLoad = true;
      this.loader = this.otloader;

      let s = 1;
      let m = 0;
      let h = 0;
      this.timer = window.setInterval(function () {
        if (s == 60) {
          m++;
          s = 0;
        }
        if (m == 60) {
          h++;
          s = 0;
          m = 0;
        }
        if (h < 10) document.getElementById("hora").innerHTML = "0" + h + "h:";
        else document.getElementById("hora").innerHTML = h + "h:";
        if (s < 10)
          document.getElementById("segundo").innerHTML = "0" + s + "s";
        else document.getElementById("segundo").innerHTML = s + "s";
        if (m < 10)
          document.getElementById("minuto").innerHTML = "0" + m + "m:";
        else document.getElementById("minuto").innerHTML = m + "m:";
        s++;
      }, 1000);

      cloneData.P_DTMES = Util.getFilterInSession().DTMESCARD;
      cloneData.CDOPERADOR = Util.getLocalVar("userData").CDOPERADOR;
      cloneData.P_VRCUSTPADR = Util.getFilterInSession().VRCUSTPADR;
      cloneData.VLR_CUSTO_MIN = Util.getFilterInSession().VLR_CUSTO_MIN;
      cloneData.VLR_CUSTO_MAX = Util.getFilterInSession().VLR_CUSTO_MAX;
      cloneData.P_SEMHISTORICO = !!enviarPratoSemHistorico;
      cloneData.parsedCardapio = JSON.parse(Util.getFilterInSession().parsedCardapio)

      requestModule
        .postRequest(`caloptServer`, {
          FROM: "generateCard",
          cloneData
        })
        .then(response => {
          response = response && response.dataset && response.dataset.cardIntStatus;
          if (typeof (response && response[0]) == 'string') {
            response = JSON.parse(response[0]);
          }

          if (response.sucesso) {
            this.steps[2].active = true;
            this.shouldLoad = false;
            this.notShowingCard = false;
            if(response.data.dataCatalog){
              OptimizerController.fixIdPrato(response.data.dataCatalog, Util.getFilterInSession().CDFILIAL);
            }
            this.cardData = response.data;
            this.showStepData = false;
            this.cardData.backOfficeData = Util.getFilterInSession();

            this.insertCenario(null);
          } else {
            let error = response;
            Util.showErrorNotificationFixed({
              text:
                t(error.otmmessage) ||
                t('reload_the_page_and_try_again'),
              title: t(error.title) || t('error_contacting_the_server')
            });
            console.log(error);
          }
        })
        .catch(error => {
          Util.showErrorNotification({
            text: t('reload_the_page_and_try_again'),
            title: t('error_contacting_the_server')
          });
          console.log(error);
        })
        .finally(() => {
          window.clearInterval(this.timer);
        });
    },
    stepManager: function () {
      if (this.currentStep == 0) {
        if (Util.getFilterInSession() && Util.getFilterInSession().VLR_CONGELADO > 0) {
          let sf = this;
          this.$modal.show({
            template: `
                  <div id="default-modal">
                      <a class="confirm-label">{{$t('menu_generated_with_frozen_days', {PARAM: ${Util.getFilterInSession().VLR_CONGELADO}})}}</a>
                      <div class="buttons-container">
                          <div class="button" style="width: 50%" id="confirm" @click="prosseguir(true)">
                              {{$t('confirm')}}
                          </div>
                          
                          <div class="button"  style="width: 50%" id="cancel" @click="prosseguir(false)">
                              {{$t('cancel')}}
                          </div>
                      </div>
                  </div>
              `,
            methods: {
              prosseguir(status) {
                this.$emit('close');
                if (status) {
                  sf.firstStep();
                }
              }
            }
          }, {}, {
            height: 'auto',
            resizable: false
          });
        } else {
          this.firstStep();
        }
      } else if (this.currentStep == 1) {
        this.showUnconsideredPlates = !this.showUnconsideredPlates;
        //this.secondStep();
      }
      // this.currentStep++;
    },
    visibilityModeChanged: function (mode) {
      this.exibitionMode = mode;
    },
    loadCenarios: function (nrcenarioResp, options = {}) {
      const { scenarioStateFromInsert = null } = options;
      return requestModule
        .postRequest(`getData`, {
          FROM: "CENARIOWOJ",
          PARAMS: {
            NRCENARIOCARD: null,
            CDFILIAL: Util.getFilterInSession().CDFILIAL,
            CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
            DTMESCARD: Util.getFilterInSession().DTMESCARD,
            IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO,
            NRORG: Util.getLocalVar("userData").NRORG,
            N_O: t('N_O'),
            CENARIO_ORIGINAL: t('CENARIO_ORIGINAL')
          }
        })
        .then(response => {
          this.cenarios = response.dataset.data;
          if (nrcenarioResp) {
            const cenarioSelecionado = this.cenarios.find(
              c => parseInt(c.NRCENARIOCARD) == parseInt(nrcenarioResp)
            );
            this.nrcenario = cenarioSelecionado
              ? {
                ...cenarioSelecionado,
                ...(scenarioStateFromInsert || {})
              }
              : null;
          } else {
            this.nrcenario = null;
          }
          return null;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  #default-modal {
    .confirm-label {
      position: relative;
      display: block;
      margin: auto;
      text-align: center;
      padding: 15px 0;
      font-weight: 600;
    }

  .buttons-container {
    position: relative;
    display: flex;
    justify-content: center;
    gap: 10px;

    .button {
      bottom: 0;
      width: 168px;
      text-align: center;
      background-color: #ffffff;
      color: #36446f;
      font-size: 0.9rem;
      margin: 5px 0;
      border-radius: 8px;
      border: 1px solid rgba(33, 33, 70, 0.18);
      box-shadow: 0 6px 16px rgba(19, 24, 41, 0.14);
      transition: background-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;

      &:hover {
        background-color: #dc143d;
        color: white;
        box-shadow: 0 12px 28px rgba(19, 24, 41, 0.18);
        transform: translateY(-1px);
      }
    }
  }
}
</style>
<style scoped lang="less">
@import (reference) url("../../assets/variables.less");

.grided-template {
  --optimizer-motion-duration: 160ms;
  --optimizer-motion-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --optimizer-radius-card: 8px;
  --optimizer-radius-modal: 12px;
  --optimizer-shadow-soft: 0 6px 16px rgba(19, 24, 41, 0.12);
  --optimizer-shadow-raised: 0 12px 28px rgba(19, 24, 41, 0.16);
  --optimizer-text-secondary: #4a5a86;
}

.card-usg-warning {
  position: relative;
  display: flex;
  padding: 10px 0;

  .warning {
    font-weight: 500;
    position: relative;
    display: block;
    margin: auto;
    border: 1px solid rgba(45, 54, 86, 0.18);
    background: rgba(255, 255, 255, 0.92);
    padding: 11px 14px;
    border-radius: var(--optimizer-radius-card);
    box-shadow: var(--optimizer-shadow-soft);
    max-width: 520px;

    span {
      text-align: center;
      display: block;
      color: #1f2747;
      line-height: 1.4;

      .three-dots {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 18px;
        margin: 0 5px;
        border: 1px solid rgba(31, 39, 71, 0.22);
        background: rgba(31, 39, 71, 0.06);
        border-radius: 999px;
        vertical-align: middle;

        i {
          font-size: 0.8rem;
          color: var(--optimizer-text-secondary);
        }
      }
    }
  }
}

.loading-gif {
  .full;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;

  .default-animation;
  opacity: 0;
  pointer-events: none;
  z-index: 20;

  &.visible {
    opacity: 1;
  }

  &::before {
    content: "";
    position: absolute;
    width: 122px;
    height: 122px;
    border-radius: 50%;
    border: 2px solid rgba(33, 33, 70, 0.16);
    border-top-color: rgba(33, 33, 70, 0.72);
    border-right-color: rgba(30, 44, 108, 0.52);
    animation: subtleLoaderRing 1.35s linear infinite;
    box-shadow: 0 0 0 1px rgba(19, 24, 41, 0.12);
  }

  img {
    position: relative;
    z-index: 1;
    display: block;
    width: 108px;
    height: 108px;
    border-radius: 999px;
    clip-path: circle(50% at 50% 50%);
    -webkit-clip-path: circle(50% at 50% 50%);
    object-fit: cover;
    overflow: hidden;
    background: #dc143d;
    box-shadow: var(--optimizer-shadow-raised);
  }
}

@keyframes subtleLoaderRing {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.card-container-result {
  position: relative;
  margin-top: 18px;
  padding: 14px 14px 16px;
  border-radius: var(--optimizer-radius-card);
  border: 1px solid rgba(33, 33, 70, 0.12);
  background: linear-gradient(180deg, #fbfcff 0%, #f4f7fe 100%);
  box-shadow: var(--optimizer-shadow-soft);
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 4px;
    background: linear-gradient(90deg, #1e2c6c 0%, #3f51b5 48%, #e03d4f 100%);
    opacity: 0.85;
  }

  &::after {
    content: "";
    position: absolute;
    width: 260px;
    height: 260px;
    right: -130px;
    top: -130px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(30, 44, 108, 0.08) 0%, rgba(30, 44, 108, 0) 70%);
    pointer-events: none;
  }

  &:hover {
    border-color: rgba(33, 33, 70, 0.18);
    box-shadow: var(--optimizer-shadow-raised);
  }

  > * {
    position: relative;
    z-index: 1;
  }

  /deep/ .anal-data-master-container,
  /deep/ .frequencia-anal-container {
    margin-top: 0;
  }
}

.result-tab-actions {
  position: fixed;
  top: 100px;
  right: 18px;
  z-index: 14;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.result-tab-icon {
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  i {
    color: #fff;
    font-size: 18px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.result-tab-panel {
  min-height: 200px;

  .card-container-result:first-of-type {
    margin-top: 14px;
  }
}

.result-tab-skeleton {
  border: 1px solid rgba(33, 33, 70, 0.1);
  border-radius: var(--optimizer-radius-card);
  background: #fff;
  padding: 12px;

  .tab-skeleton-header {
    height: 34px;
    border-radius: var(--optimizer-radius-card);
    margin-bottom: 10px;
    background: linear-gradient(90deg, rgba(230, 230, 230, 0.8) 25%, rgba(245, 245, 245, 0.95) 50%, rgba(230, 230, 230, 0.8) 75%);
    background-size: 220% 100%;
    animation: scenarioShimmer 1.4s ease-in-out infinite;
  }

  .tab-skeleton-lines {
    display: grid;
    gap: 8px;

    > span {
      display: block;
      height: 44px;
      border-radius: var(--optimizer-radius-card);
      background: linear-gradient(90deg, rgba(230, 230, 230, 0.8) 25%, rgba(245, 245, 245, 0.95) 50%, rgba(230, 230, 230, 0.8) 75%);
      background-size: 220% 100%;
      animation: scenarioShimmer 1.4s ease-in-out infinite;
    }
  }
}

.chat-tab-panel {
  padding-right: 10px;
}

.chat-empty-warning {
  margin-top: 30px;
}

.scenario-grid-skeleton {
  margin-top: 12px;
  padding-right: 15px;

  .skeleton-labels,
  .skeleton-row {
    display: grid;
    grid-template-columns: 170px minmax(0, 1fr) 170px;
    gap: 8px;
    margin-bottom: 8px;
  }

  .skeleton-body {
    display: grid;
    gap: 8px;
  }

  .skeleton-grid {
    display: grid;
    gap: 8px;
  }

  .skeleton-block {
    display: block;
    height: 56px;
    border-radius: var(--optimizer-radius-card);
    background: linear-gradient(90deg, rgba(230, 230, 230, 0.8) 25%, rgba(245, 245, 245, 0.95) 50%, rgba(230, 230, 230, 0.8) 75%);
    background-size: 220% 100%;
    animation: scenarioShimmer 1.4s ease-in-out infinite;

    &.fixed {
      min-height: 56px;
    }
  }
}

.card-container.scenario-loading {
  /deep/ .arrow,
  /deep/ .arrow-secondary,
  /deep/ .arrow-tertiary,
  /deep/ .changed-mark,
  /deep/ .attached-mark,
  /deep/ .padlock,
  /deep/ .ings-container {
    opacity: 0 !important;
  }

  /deep/ .cell,
  /deep/ .title,
  /deep/ .anal-data span,
  /deep/ .anal-data-container span {
    color: transparent !important;
  }

  /deep/ .cell-container,
  /deep/ .container-max,
  /deep/ .anal-data,
  /deep/ .anal-data-container,
  /deep/ .chat-container .chart,
  /deep/ .card-container-result {
    position: relative;
    border-radius: var(--optimizer-radius-card);
    overflow: hidden;
  }

  /deep/ .cell-container::after,
  /deep/ .container-max::after,
  /deep/ .anal-data::after,
  /deep/ .chat-container .chart::after,
  /deep/ .card-container-result::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: var(--optimizer-radius-card);
    background: linear-gradient(90deg, rgba(230, 230, 230, 0.82) 25%, rgba(245, 245, 245, 0.96) 50%, rgba(230, 230, 230, 0.82) 75%);
    background-size: 220% 100%;
    animation: scenarioShimmer 1.4s ease-in-out infinite;
  }
}

@keyframes scenarioShimmer {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: -100% 50%;
  }
}

.card-container {
  @defaultHeight: calc(100vh - 53px);
  @altHeight: calc(100vh - 105px);
  margin: 0 5px;
  height: 100%;
  // scroll-snap-type: y mandatory;
  overflow-y: scroll;

  >div {

    //scroll-snap-align: start;
    &:not(:first-of-type) {
      padding-right: 15px;
    }
  }

  &.empty {
    height: @altHeight;

    >div {
      height: @altHeight;
    }
  }
}

.loader {
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  height: calc(100vh - 190px);
}

.otimizador-main-screen {
  position: relative;
  transition: padding-top 0.22s ease;

  .standalone-scenario-picker {
    margin: 0 5px 6px;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 6px 10px;
  }

  .headerAproach {
    margin-top: -5px;
  }

  .timer {
    position: absolute;
    text-align: center;
    display: flex;
    bottom: 0;
    right: 0;
    left: 0;

    .timer-center {
      display: flex;
      margin: auto;
      text-align: center;
      vertical-align: middle;
      font-size: 6rem;
      color: #fff;
      filter: drop-shadow(1px 1px 2px black);
    }

    font-family: "Share Tech Mono";
  }

  .otimizador-container {
    overflow: hidden auto;

    //height: calc(100vh - 160px);
    &.loading {
      padding: 0;
      height: -webkit-fill-available;
      overflow: hidden;
    }

    .arrow {
      z-index: 10;
      .sombra;
      .clicavel;
      .default-hover;
      position: fixed;
      right: 35px;
      bottom: 15px;
      border-radius: 100%;
      display: table;

      .arr {
        width: 60px;
        height: 60px;
        padding: 0;
        vertical-align: middle;
        display: flex;
        margin: auto;
        text-align: center;
        color: white;
        font-size: 30px;
        line-height: 20px;

        span {
          display: flex;
          margin: auto;
          font-size: 30px;
          padding: 0 5px 5px 8px;
        }
      }

      .desc {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        vertical-align: middle;
        margin: auto;
        display: table;
        font-size: 0.82rem;
        font-weight: 700;
        color: white;
        background: @vermelho;
        padding: 5px 10px;
        border-radius: 8px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border: 1px solid rgba(255, 255, 255, 0.16);
        box-shadow: var(--optimizer-shadow-soft);
        opacity: 0;
        .default-animation;
      }

      &:hover .desc {
        background: @azul;
        opacity: 1;
        right: 45px;
      }
    }
  }

  .chat-container {
    position: relative;

    .title {
      padding-top: 15px;
      // border-top: solid 1px rgba(0, 0, 0, 0.1);
      display: block;
      text-align: center;
      margin: 30px 0 0px 0;
      font-size: 1.3rem;
      color: @vermelho;
    }

    .chart {
      display: table;
      margin: auto;
    }
  }
}

@media screen and (max-width: 900px) {
  .result-tab-actions {
    top: 72px;
    right: 10px;
    gap: 8px;
  }
}

.optimizer-header-slide-enter-active,
.optimizer-header-slide-leave-active {
  transition: opacity var(--optimizer-motion-duration) var(--optimizer-motion-ease), transform var(--optimizer-motion-duration) var(--optimizer-motion-ease);
}

.optimizer-header-slide-enter,
.optimizer-header-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.optimizer-settings-slide-enter-active,
.optimizer-settings-slide-leave-active {
  transition: opacity var(--optimizer-motion-duration) var(--optimizer-motion-ease), transform var(--optimizer-motion-duration) var(--optimizer-motion-ease);
}

.optimizer-settings-slide-enter,
.optimizer-settings-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.result-tab-switch-enter-active,
.result-tab-switch-leave-active {
  transition: opacity var(--optimizer-motion-duration) var(--optimizer-motion-ease), transform var(--optimizer-motion-duration) var(--optimizer-motion-ease);
}

.result-tab-switch-enter,
.result-tab-switch-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
</style>
